import { SvgIcon, type SvgIconProps } from '../svgIcon'

export const LinkedinIcon = ({
  width = 20,
  height = 20,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <g clipPath="url(#clip0_4612_19840)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8325 8.98236V8.95312C10.8263 8.96293 10.8178 8.97273 10.8125 8.98236H10.8325Z"
        fill="#E3E3E3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V20H20V0H0ZM6.22075 16.6155H3.25345V7.68818H6.22075V16.6155ZM4.7371 6.46972H4.71749C3.72211 6.46972 3.07692 5.78396 3.07692 4.92681C3.07692 4.05086 3.74097 3.38453 4.75653 3.38453C5.77231 3.38453 6.39653 4.05086 6.41596 4.92681C6.41596 5.78396 5.77231 6.46972 4.7371 6.46972ZM16.9231 16.6155H13.955V11.8393C13.955 10.6397 13.5262 9.82088 12.4519 9.82088C11.6315 9.82088 11.144 10.3722 10.9292 10.9063C10.8512 11.0971 10.8308 11.3622 10.8308 11.6298V16.6155H7.86211C7.86211 16.6155 7.90189 8.52571 7.86211 7.68822H10.8308V8.95323C11.2252 8.34633 11.9291 7.47864 13.5058 7.47864C15.459 7.47864 16.9231 8.75424 16.9231 11.4961V16.6155Z"
        fill="#E3E3E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_4612_19840">
        <rect width="20" height="20" rx="2" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)
